import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, HttpBackend } from '@angular/common/http';
import { authInterceptor, reLoginInterceptor } from './core/service/auth/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { translateHttpLoaderFactory } from './core/i18n/translate-loader.factory';
import { acceptLanguageInterceptor } from './core/i18n/accept-language.interceptor';

// Re-skins the stock Aura preset with the product's brand green (#01d47e at
// the 500 step) instead of Aura's default blue, so every PrimeNG component
// (buttons, tables, dropdowns, tags, dialogs...) picks up the brand color
// with no per-component overrides needed. Component-level radius tokens push
// buttons/tags to a pill shape while keeping inputs/cards gently rounded,
// matching the supplier-facing storefront's softer visual language.
const MySupplyzPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#ecfdf5',
      100: '#d1fae5',
      200: '#a7f3d0',
      300: '#6ee7b7',
      400: '#34d399',
      500: '#01d47e',
      600: '#00b86c',
      700: '#009457',
      800: '#067a4a',
      900: '#065f37',
      950: '#033a22'
    }
  },
  components: {
    button: { root: { borderRadius: '999px' } },
    tag: { root: { borderRadius: '999px' } },
    card: { root: { borderRadius: '16px' } },
    inputtext: { root: { borderRadius: '10px' } },
    select: { root: { borderRadius: '10px' } },
    confirmdialog: { icon: { color: '{yellow.500}' }, content: { gap: '0.35rem' } }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([acceptLanguageInterceptor, authInterceptor, reLoginInterceptor])),
    provideAnimationsAsync(),
    MessageService,
    ConfirmationService,
    DatePipe,
    DialogService,
    providePrimeNG({
      theme: {
        preset: MySupplyzPreset,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    }),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpBackend]
      }
    })
  ]
};
